import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

// Import components
import { Main } from './helpers/components';
import { RouteWithHelmet } from 'components/elements';

// Import routes
import { appRoutes } from './helpers/routes';

const ProtectedRoutes = () => {
	return (
		<Switch>
			<Redirect exact path="/" to="/strona-glowna" />
			{appRoutes.map(({ path, ...route }) => (
				<RouteWithHelmet key={path} path={path} {...route} />
			))}
			<Main />
			<Redirect to="/strona-glowna" />
		</Switch>
	);
};

export default ProtectedRoutes;
